import {socket} from "../../../store/actions";
import {socketHandler} from "ubs-framework/v2/common/function";

const useSocket = (cb, name = 'handler') => {
    const handler = {
        [name]:(r) => cb(socketHandler(r))
    }
    return {
        refresh: () => {
            socket.off('response', handler[name])
            socket.on('response', handler[name])
        },
        on: () => socket.on('response', handler[name]),
        off: () => socket.off('response', handler[name])
    }
};

export default useSocket;